import { render, staticRenderFns } from "./official_website_index.vue?vue&type=template&id=6b480658&scoped=true"
import script from "./official_website_index.vue?vue&type=script&lang=js"
export * from "./official_website_index.vue?vue&type=script&lang=js"
import style0 from "./official_website_index.vue?vue&type=style&index=0&id=6b480658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b480658",
  null
  
)

export default component.exports